<script lang="ts">
import { computed, defineComponent } from "vue";
import storeUtils from "@/businesslogic/utils/storeUtils";
import gebaeudeUtils from "@/businesslogic/utils/gebaeudeUtils";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "GebaeudedatenUbersicht",
  setup(props) {
    const piniaStore = useFormStore();
    const { enthaeltVHV, istFhkVerkaufsprodukt } = storeUtils();

    const gebaeudetypText = computed(() => {
      if (istFhkVerkaufsprodukt(piniaStore.state)) {
        if (piniaStore.state.gebaeudedaten.immobilieArt === "2") {
          return "Ferienwohnung";
        }
      }
      return gebaeudeUtils().gebaeudeSubTypLabel(
        piniaStore.state.gebaeudedaten.gebaeudesubtyp,
        piniaStore.state.gebaeudedaten.anzahlWohnungen,
      );
    });

    const kompletterText = computed(() => {
      const elemente: string[] = [];

      elemente.push(gebaeudetypText.value);
      elemente.push(piniaStore.state.risikoAnschrift.strasse + " " + piniaStore.state.risikoAnschrift.hausnummer);
      elemente.push(piniaStore.state.risikoAnschrift.plz + " " + piniaStore.state.risikoAnschrift.ort);
      if (!istFhkVerkaufsprodukt(piniaStore.state) || !enthaeltVHV(piniaStore.state)) {
        elemente.push("Baujahr: " + piniaStore.state.gebaeudedaten.baujahr);
        elemente.push(piniaStore.state.gebaeudedaten.gewerbeVorhanden ? "Gewerbe: ja" : "");
        if (piniaStore.state.gebaeudedaten.gewerbeVorhanden && piniaStore.state.isMakler) {
          let gewerbenamen = "";
          for (const gewerbe of piniaStore.state.gebaeudedaten.gewerbeListe) {
            if (gewerbe.beschreibung != "") {
              gewerbenamen += "(" + gewerbe.beschreibung + ")";
            }
          }
          elemente.push(gewerbenamen);
        }
        elemente.push(dachvarianteText.value);
        elemente.push(geschosseText.value);
        elemente.push(piniaStore.state.gebaeudedaten.kellerVorhanden ? "Keller" : "");
        elemente.push(garagenCarportsText.value);
        elemente.push(piniaStore.state.gebaeudedaten.photovoltaikVorhanden === true ? "Photovoltaikanlage" : "");
      }

      return elemente.filter((e) => String(e).trim()).join(", ");
    });

    const garagenCarportsText = computed(() => {
      if (!piniaStore.state.gebaeudedaten.parkplaetzeVorhanden) {
        return "";
      }

      let text = "";
      const garagen = piniaStore.state.gebaeudedaten.anzahlGaragen;
      const carports = piniaStore.state.gebaeudedaten.anzahlCarports;
      const hatGaragen = garagen !== null && garagen > 0;
      const hatCarports = carports !== null && carports > 0;

      if (hatGaragen) {
        text += garagen + (garagen == 1 ? " Garagenstellplatz" : " Garagenstellplätze");
      }
      if (hatCarports && hatGaragen) {
        text += " / ";
      }
      if (hatCarports) {
        text += carports + (carports == 1 ? " Carport" : " Carports");
      }
      return text;
    });

    const dachvarianteText = computed(() => {
      switch (piniaStore.state.gebaeudedaten.dachvariante) {
        case "1":
          return "Flachdach";
        case "2":
          return "Kein Dachausbau";
        case "3":
          return "Dachausbau";
      }

      return "";
    });

    const geschosseText = computed(() => {
      return (
        piniaStore.state.gebaeudedaten.anzahlVollgeschosse +
        (piniaStore.state.gebaeudedaten.anzahlVollgeschosse == 1 ? " Geschoss" : " Geschosse")
      );
    });

    return {
      props,
      piniaStore,
      gebaeudetypText,
      garagenCarportsText,
      dachvarianteText,
      geschosseText,
      kompletterText,
    };
  },
});
</script>

<template>
  {{ kompletterText }}
</template>
